<template>
  <article class="ui-card__article">
    <forms-input
      :errors="getErrors('amount')"
      input-type="number"
      :placeholder="$t('sayl.placeholder')"
      :read-only="readOnly"
      required
      type="number"
      @input="onRemoveError('amount')"
      v-model.number="edition.amount">
      <template>{{ $t('sayl.tier_amount_points_label') }}</template>
      <template #suffix>{{ pointsSymbol }}</template>
    </forms-input>
  </article>
</template>

<script>
import { mapState } from 'vuex'

import { MixinError } from '@sayl/admin-common'

export default {
  name: 'TierEditionTypePoint',

  mixins: [
    MixinError,
  ],

  props: {
    errors: {},
    
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      program: state => state.loyalty.loyalty.edition,
      edition: state => state.tier.tier.edition,
    }),

    pointsSymbol() {
      return this.$basil.get(this.program, 'points.symbol')
    }
  },
}
</script>